const initialState = {
    scenarioCategories: [],
    scenarioLocationTypes: [],
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'CUSTOMER_SCENARIO_CATEGORIES_SUCCESS') {
        return {
            ...state,
            scenarioCategories: action.payload,
        };
    }

    if (action.type === 'CUSTOMER_SCENARIO_LOCATION_TYPES_SUCCESS') {
        return {
            ...state,
            scenarioLocationTypes: action.payload,
        };
    }

    return state;
}

export default reducer;
